import { TextField as KobalteTextField } from "@kobalte/core/text-field"
import type { ComponentProps } from "solid-js"
import {
  textFieldClass,
  textFieldDescriptionClass,
  textFieldErrorMessageClass,
  textFieldInputClass,
  textFieldLabelClass,
} from "./text-field.css"

export function TextField(props: ComponentProps<typeof KobalteTextField>) {
  return (
    <KobalteTextField
      {...props}
      class={[textFieldClass, props.class].join(" ")}
    />
  )
}

function TextFieldLabel(props: ComponentProps<typeof KobalteTextField.Label>) {
  return (
    <KobalteTextField.Label
      {...props}
      class={[textFieldLabelClass, props.class].join(" ")}
    />
  )
}

function TextFieldInput(props: ComponentProps<typeof KobalteTextField.Input>) {
  return (
    <KobalteTextField.Input
      {...props}
      class={[textFieldInputClass, props.class].join(" ")}
    />
  )
}

function TextFieldTextArea(
  props: ComponentProps<typeof KobalteTextField.TextArea>,
) {
  return (
    <KobalteTextField.TextArea
      {...props}
      class={[textFieldInputClass, props.class].join(" ")}
    />
  )
}

function TextFieldDescription(
  props: ComponentProps<typeof KobalteTextField.Description>,
) {
  return (
    <KobalteTextField.Description
      {...props}
      class={[textFieldDescriptionClass, props.class].join(" ")}
    />
  )
}

function TextFieldErrorMessage(
  props: ComponentProps<typeof KobalteTextField.ErrorMessage>,
) {
  return (
    <KobalteTextField.ErrorMessage
      {...props}
      class={[textFieldErrorMessageClass, props.class].join(" ")}
    />
  )
}

TextField.Label = TextFieldLabel
TextField.Input = TextFieldInput
TextField.TextArea = TextFieldTextArea
TextField.Description = TextFieldDescription
TextField.ErrorMessage = TextFieldErrorMessage
